import '../vendor/bootstrap.scss'
import './index.scss'
import $ from 'jquery'
import '../vendor/bootstrap'
import { setUpTNTSlider } from './plano-tnt-slider'
import { setUpAuthModals } from '../components/auth-modals'
import { setUpFooter } from '../components/footer'
import { setUpHeaderButtons } from '../components/header'
import { setUpAprendaBanner } from '../components/banner'

// External dependencies
let courses
let coursesProgresses

function updateCoursesProgresses() {
  if (coursesProgresses.length > 0) {
    $('.section-courses:not(.product-courses) .card-body').append(
      '<div class="course-status-wrapper position-absolute"><span class="badge badge-light">Não Iniciado</span></div>'
    )
    $('#course_card_commodities .course-status-wrapper').remove()
  }
  courses.forEach((course) => {
    let completedChapters = 0
    let started = false
    coursesProgresses.forEach((prog) => {
      if (prog.courseSlug === course.courseSlug) {
        started = true
        if (prog.completed) {
          completedChapters++
        }
      }
    })
    if (
      $(`#course_card_${course.courseSlug}`).find('.btn-product').length > 0 &&
      started
    ) {
      $('#btn_choose_course')
        .attr('href', `/${course.folder}/go-to-last-lecture`)
        .html(
          `<i class="fa fa-chevron-right fa-2x mr-2"></i><strong>Continuar Plano</strong>`
        )
      $('.choose-course-cta').text('Continue suas aulas')
      const btnElem = $(`#course_card_${course.courseSlug}`).find(
        '.btn-product'
      )
      const order = btnElem.data().order
      const orderLabel = btnElem.data().orderLabel
      return $(`#course_card_${course.courseSlug}`)
        .find('.btn-product')
        .html(`<i class="fa fa-play"></i> Continuar ${orderLabel} ${order}`)
    }
    if (completedChapters === course.chapters.length) {
      return $(`#course_card_${course.courseSlug} .badge`)
        .removeClass('badge-secondary badge-light')
        .addClass('badge-success')
        .html('Concluído')
    }
    if (started) {
      $(`#course_card_${course.courseSlug} .badge`)
        .removeClass('badge-light')
        .addClass('badge-secondary')
        .html('Iniciado')
      $(`#course_card_${course.courseSlug}`)
        .find('.course-btn-label')
        .text('continuar curso gratuito')
    }
  })
}

function formatDuration(durationString) {
  const re = /(h)|(\s?min(utos)?\.?)/gi
  const matches = durationString.match(re)
  if (!matches || !durationString) {
    return `${durationString} mins`
  }
  if (matches.includes('h')) {
    return durationString
  }
  return `${durationString.replace(re, '')} mins`
}

function updateCourseDuration() {
  $('.course-duration').each(function (i, item) {
    const durationString = $(item).data('duration').toString()
    const formattedText = formatDuration(durationString)
    $(item).text(formattedText)
  })
}

$(document).ready(function () {
  // Initialize variables after all scripts have been loaded
  courses = window.courses
  coursesProgresses = window.coursesProgresses

  setUpHeaderButtons()
  updateCourseDuration()
  updateCoursesProgresses()
  setUpTNTSlider()
  setUpAuthModals()
  setUpFooter()
  setUpAprendaBanner()
})
